import { render } from "./ConfigurationOptionsType.vue?vue&type=template&id=5b606024&scoped=true"
import script from "./ConfigurationOptionsType.vue?vue&type=script&lang=js"
export * from "./ConfigurationOptionsType.vue?vue&type=script&lang=js"

import "./ConfigurationOptionsType.vue?vue&type=style&index=0&id=5b606024&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b606024"]])

export default __exports__